document.addEventListener('DOMContentLoaded', function () {
    // Function to show the selected section and update active link
    function showSection(sectionId) {
        const sections = document.querySelectorAll('.services-sec-c');
        const links = document.querySelectorAll('.sd-tabs-nav ul li');

        sections.forEach(section => {
            if (section.id === sectionId) {
                section.classList.add('active');
            } else {
                section.classList.remove('active');
            }
        });

        links.forEach(link => {
            const linkSectionId = link.getAttribute('data-section');
            if (linkSectionId === sectionId) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    }

    // Add click event listeners to each link
    const links = document.querySelectorAll('.sd-tabs-nav ul li');
    links.forEach(link => {
        link.addEventListener('click', function () {
            const sectionId = this.getAttribute('data-section');
            showSection(sectionId);
        });
    });

    // Show the initial section (you can set the default section here)

});




jQuery(function ($) {
    $(".accordion-content").css("display", "none");

    $(".accordion h4").click(function () {
        $(".accordion h4").not(this).removeClass("open");
        $(".accordion h4").not(this).next().slideUp(300);
        $(this).toggleClass("open");
        $(this).next().slideToggle(300);
    });
});



function Swiperrrrrr() {
  var swiper = new Swiper(".prodSlider", {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: ".prodSlider-next",
      prevEl: ".prodSlider-prev",
    },
    breakpoints: {
      100: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      575: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  var swiper = new Swiper(".tstSlider", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".tst-pagination",
      clickable: true,
    },
  });
}
Swiperrrrrr();

function servicesSidebar() {
  const sideBar = document.querySelector(".svcs-sidebar");
  const toggler = document.querySelector(".sb-toggle");
  const overlay = document.querySelector(".sb-overlay");
  toggler.addEventListener("click", function () {
    sideBar.classList.toggle("active");
  });
  overlay.addEventListener("click", function () {
    sideBar.classList.toggle("active");
  });
}
servicesSidebar();

function scrollSpy() {
  $(document).ready(function () {
    var sectionIds = $(".spyNav a");

    $(document).scroll(function () {
      sectionIds.each(function () {
        var container = $(this).attr("href");
        var containerOffset = $(container).offset().top;
        var containerHeight = $(container).outerHeight();
        var containerBottom = containerOffset + containerHeight;
        var scrollPosition = $(document).scrollTop();

        if (
          scrollPosition < containerBottom - 20 &&
          scrollPosition >= containerOffset - 20
        ) {
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });
    });
  });
}
scrollSpy();

function servicesTabs() {
  const tabsNav = document.querySelectorAll('.s-downloads .sd-tabs-nav ul li');
  const tabsContent = document.querySelectorAll('.s-downloads .sd-tab-c-displayer .sd-tab-content');
  
  tabsNav.forEach((items, ind) => {
      items.addEventListener('click', () => {
          tabsNav.forEach((remove) => {
              remove.classList.remove('active')
          })
  
          items.classList.add('active')
  
          tabsContent.forEach((content) => {
              content.classList.remove('active')
          })
  
          tabsContent[ind].classList.add('active')
      })
  })
}
servicesTabs()






    